import { render, staticRenderFns } from "./group.vue?vue&type=template&id=165c1fc0&"
import script from "./group.vue?vue&type=script&lang=js&"
export * from "./group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "group.vue"
export default component.exports